/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class DarkMode extends ThemeComponent {
    @Ref switchButton !: HTMLButtonElement;
    @Ref buttonText !: HTMLSpanElement;

    init() {
        this.initEvents();
    }

    initEvents() {
        const buttonsArray = ['Dark Mode', 'Light Mode'];
        this.buttonText.innerText = buttonsArray[0];
        const html = document.querySelector('html');

        this.$listen(this.switchButton, 'click', () => {
            html?.classList.toggle('dark');

            if (this.buttonText.innerText === buttonsArray[0]) {
                this.buttonText.innerText = buttonsArray[1];
                this.setDarkModeCookie(true); // Enable dark mode and set the cookie
            } else {
                this.buttonText.innerText = buttonsArray[0];
                this.setDarkModeCookie(false); // Disable dark mode and remove the cookie
            }
        });

        // Check if dark mode is enabled and adjust the UI accordingly
        if (this.isDarkModeEnabled()) {
            html?.classList.add('dark');
            this.buttonText.innerText = buttonsArray[1];
        }
    }

    private setDarkModeCookie(enabled: boolean) {
        if (enabled) {
            document.cookie = "DarkMode=true; path=/";
        } else {
            // To remove a cookie, set an expiration date in the past
            document.cookie = "DarkMode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
    }

    private isDarkModeEnabled() {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith("DarkMode=")) {
                // Extract the value after the "=" sign
                const value = cookie.substring("DarkMode=".length);
                // Check if the value is "true"
                return value === "true";
            }
        }
        // Return false if the cookie is not found or its value is not "true"
        return false;
    }
}
